import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getStatusIdsByCategory } from '../../utility/evidenceDashboardHelper';
import { PORTAL_STAT_TILES_CONFIG } from '../../constants/evidencePortalConstants';

const sameFilter = (a, b) => JSON.stringify(a || null) === JSON.stringify(b || null);

const EvidencePortalStatTiles = ({ summary, tileFilter, onFilterChange }) => {
  const custodyStatuses = useSelector((state) => state.dictionary?.codeEvidenceCustodyStatus);

  const tiles = useMemo(
    () =>
      PORTAL_STAT_TILES_CONFIG.map((tile) => ({
        key: tile.key,
        label: tile.label,
        value: summary?.[tile.key] || 0,
        filter: tile.statusCategory
          ? { status: getStatusIdsByCategory(custodyStatuses, tile.statusCategory) }
          : null,
      })),
    [summary, custodyStatuses]
  );

  const handleClick = (tile) => {
    if (!tile.filter) return;
    onFilterChange(sameFilter(tileFilter, tile.filter) ? null : tile.filter);
  };

  return (
    <div className="evidence-portal-stats">
      {tiles.map((tile) => (
        <div
          key={tile.key}
          className={`evidence-portal-stat${tile.filter ? ' is-clickable' : ''}${
            sameFilter(tileFilter, tile.filter) ? ' is-active' : ''
          }`}
          onClick={() => handleClick(tile)}>
          <span className="evidence-portal-stat__value">{tile.value}</span>
          <span className="evidence-portal-stat__label">{tile.label}</span>
        </div>
      ))}
    </div>
  );
};

export default EvidencePortalStatTiles;
